import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { IdeasPage } from './pages/IdeasPage';
import { HennaPage } from './pages/HennaPage';
import { TattooPage } from './pages/TattooPage';
import { BriefPage } from './pages/BriefPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="w-full min-h-screen" data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<IdeasPage data-id="element-4" />} data-id="element-3" />
          <Route path="/brief" element={<BriefPage data-id="element-6" />} data-id="element-5" />
          <Route path="/henna" element={<HennaPage data-id="element-8" />} data-id="element-7" />
          <Route path="/tattoo" element={<TattooPage data-id="element-10" />} data-id="element-9" />
        </Routes>
      </div>
    </BrowserRouter>;
}